<template>
  <div ref="element">
    <router-link
      :to="{
        name: 'NotificationDetail',
        params: { notificationId: notification.id },
      }"
    >
      <div
        class="px-10 py-6 text-left text-gray-92 hover:bg-slate-50 border-gray-12"
        :class="{ 'border-t': !isFirstItem }"
      >
        <div class="flex items-start">
          <span class="w-24">{{ notification.start_at }}</span>
          <div class="flex-1 flex justify-between items-center">
            <div class="flex">
              <div style="width: 10px; height: 10px">
                <span
                  v-if="notification.is_unread"
                  class="inline-block bg-coral-main rounded-full"
                  style="width: 10px; height: 10px"
                ></span>
              </div>
              <div class="font-semibold mx-4">
                {{ notification.subject }}
              </div>
            </div>

            <img class="w-4" src="@/assets/icons/ChevronRight.svg" />
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
export default {
  props: {
    notification: Object,
    checkForGetApi: Boolean,
    isFirstItem: Boolean,
  },
  emits: ['get-api'],
  setup(props, context) {
    const element = ref(null);

    onMounted(() => {
      if (props.checkForGetApi) {
        checkCardInViewport();
        window.addEventListener('scroll', checkCardInViewport);
      }
    });
    const checkCardInViewport = () => {
      if (props.checkForGetApi) {
        let rect = element.value.getBoundingClientRect();
        if (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
            (window.innerWidth || document.documentElement.clientWidth)
        ) {
          context.emit('get-api');
          window.removeEventListener('scroll', checkCardInViewport);
        }
      }
    };

    return {
      element,
    };
  },
};
</script>

<style></style>
